import Configuration from '@/classes/templates/Configuration'

export default class Template {
  constructor ({ id = null, configuration = {} } = {}) {
    this.id = id
    this.configuration = new Configuration(configuration)
  }

  get columns () {
    return this.configuration.columns
  }

  get blocks () {
    return this.configuration.blocks
  }
}